export default __webpack_public_path__ + "static/media/collection-img.eb0a4613.jpg";